import { buttonSizeTemplate, buttonVariantTemplate } from '../buttonTemplate'

export default function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  ...props
}) {
  const variantClass = buttonVariantTemplate[variant] || buttonVariantTemplate.primary
  const sizeClass = buttonSizeTemplate[size] || buttonSizeTemplate.lg

  return (
    <button
      className={`${sizeClass} font-semibold transition disabled:opacity-50 disabled:cursor-not-allowed ${variantClass} ${className}`}
      {...props}
    >
      {children}
    </button>
  )
}
